export default {
  buttons: {
    clearScreen: {
      en: "Clear",
      pt: "Limpar",
    },
    save: {
      en: "Save",
      pt: "Salvar",
    },
    layout: {
      en: "Apply automatic layout",
      pt: "Aplicar layout automático",
    },
    security: {
      en: "Security",
      pt: "Segurança",
    },
    grammar: {
      en: "grammar",
      pt: "gramática",
    },
    machine: {
      en: "machine",
      pt: "máquina",
    },
    download: { en: "download", pt: "Download" },
    tutorial: { en: "Tutorial", pt: "Tutorial" },
    profile: { en: "Profile", pt: "Perfil" },
    login: { en: "Login/Register", pt: "Entrar/Cadastrar" },
    logout: { en: "Logout", pt: "Sair" },
    optionsDraw: {
      draw: {
        en: "Draw",
        pt: "Desenho",
      },
      response: {
        en: "Response",
        pt: "Resposta",
      },
    },
  },
  alerts: {
    info: {
      changeLanguage: {
        en: "Will be need close response screen and go back input screen",
        pt: "Será preciso fechar a tela de resposta e voltar a tela de input",
      },
      exitQuestion: {
        en: "Are you sure you want to quit ?",
        pt: "Tem certeza que deseja sair ?",
      },
      nameInUse: {
        en: "Name already in use!",
        pt: "Nome já em uso!",
      },
      defaultName: {
        en: "Default name filled in!",
        pt: "Nome padrão preenchido!",
      },
      withoutData: {
        en: "Without data!",
        pt: "Sem dados!",
      },
    },
  },
  user: {
    anonymous: {
      en: "Anonymous",
      pt: "Anônimo",
    },
  },
  textField: {
    placeholder: {
      en: "Name of",
      pt: "Nome da",
    },
    emptyPlaceholder: {
      pt: "",
      en: "",
    },
  },
  automatonSelector: {
    placeholder: {
      en: "Select an Automaton",
      pt: "Selecione um Autômato",
    },
    save: {
      en: " saved",
      pt: " salvo",
    },
    update: {
      en: " updated",
      pt: " atualizado",
    },
    machineTypes: {
      AF: {
        en: "Finite Automaton",
        pt: "Autômato Finito",
      },
      AP: {
        en: "Pushdown Automaton",
        pt: "Autômato com Pilha",
      },
      ALL: {
        en: "Linearly Bounded Automaton",
        pt: "Autômato Linearmente Limitado",
      },
      MT: {
        en: "Turing Machine",
        pt: "Máquina de Turing",
      },
    },
  },
};
